export default __webpack_public_path__ + "static/media/imgNotAvailable.073a9e70.webp";